__turbopack_context__.v({
  "detail-chip-container": "feature-list-section-module-scss-module__VP6aCq__detail-chip-container",
  "gap-fallback": "feature-list-section-module-scss-module__VP6aCq__gap-fallback",
  "section-subtitle": "feature-list-section-module-scss-module__VP6aCq__section-subtitle",
  "section-title": "feature-list-section-module-scss-module__VP6aCq__section-title",
  "static-chip": "feature-list-section-module-scss-module__VP6aCq__static-chip",
});
